angular.module('bmsApp.settings').controller('EmailAccountsSaveCtrl', EmailAccountsSaveCtrl);

EmailAccountsSaveCtrl.$inject = [
	'$scope',
	'$q',
	'$state',
	'notify',
	'EmailAccountsDataSvc',
];

function EmailAccountsSaveCtrl(
	$scope,
	$q,
	$state,
	notify,
	EmailAccountsDataSvc
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		init: init,
		handlers: handlers,
		formObj: null,
		loaded: false,
		emailAccount: {
			id: null,
		},
	});

	function init() {
		let promises = {
			licences: EmailAccountsDataSvc.licencesOptions(),
		};
		if ($state.params.id) {
			promises.email_account = EmailAccountsDataSvc.read($state.params);
		}
		$q.all(promises).then((responses) => {
			if (responses.email_account !== undefined) {
				// Model
				self.formObj.assignedModelToData(self.formObj.data, responses.email_account.data.email_account);
			}
			// Licences
			self.formObj.data.licences.options = responses.licences.data.licences;
			self.loaded = true;
		});
	}

	$scope.formObj = self.formObj = {
		service: EmailAccountsDataSvc.save,
		name: 'email_account',
		redirect: () => {
			$state.go('main.settings.email-accounts.index');
		},
		errors: [],
		data: {
			id: {},
			type: {
				options: [
					{
						id: 'incoming',
						label: 'Incoming',
					},
					{
						id: 'outgoing',
						label: 'Outgoing',
					},
				],
			},
			default: {},
			label: {},
			hostname: {},
			email: {},
			username: {},
			password: {},
			port: {},
			security: {
				options: [
					{
						id: 'ssl',
						label: 'SSL',
					},
					{
						id: 'tls',
						label: 'TLS',
					},
				],
			},
			licences: {
				// options: [],
			},
		},
		assignedModelToData: (data, model) => {
			angular.forEach(model, (value, key) => {
				if (data[key] !== undefined) {
					console.info('typeof value', typeof value);
					if (typeof value === 'object' && value !== null) {
						console.info('object', key, value);
						data[key].value = [];
						angular.forEach(value, (item) => {
							data[key].value.push(item.id);
						});
					} else  {
						data[key].value = value;
					}
				}
			});
		},
		getModelFromData: (data) => {
			let model = {};
			angular.forEach(data, (item, key) => {
				model[key] = item.value;
			});
			return model;
		},
		submit: () => {
			self.formObj.errors = [];
			let model = self.formObj.getModelFromData(self.formObj.data);
			self.formObj.service(model).then((response) => {
				self.formObj.assignedModelToData(self.formObj.data, response.data[self.formObj.name]);
				if (self.formObj.redirect !== undefined) {
					notify({
						message: 'Saved',
					});
					self.formObj.redirect();
				}
			}, (errors) => {
				self.formObj.errors = errors;
			});
		},
	};
}